import React from 'react';
import { FinalFormField } from '../../common/Form/FinalFormField';
import { FinalFormFieldProps } from '../../common/Form/types';
import { Textarea, TextareaProps } from '../Textarea';

export const FinalFormTextarea: React.FC<FinalFormFieldProps & TextareaProps> = props => (
  <FinalFormField {...props}>
    {({ input, ...rest }: FinalFormFieldProps) => (
      <Textarea
        data-test-error={!!rest.hintError}
        data-test-error-message={rest.hintError}
        {...input}
        {...rest}
      />
    )}
  </FinalFormField>
);
